import {COGNITO_ERROR_MESSAGES}  from '../lang/ja.js';

export const amplifyErrorHandler = (error) => {
  const errorType = error?.__type || error?.response?.data?.error?.code || error?.code;

  console.log(errorType)
  return COGNITO_ERROR_MESSAGES[errorType] || error?.message || COGNITO_ERROR_MESSAGES.DEFAULT;
}
